import { tokenManager } from "@/features/auth/utils/token-manager";
import { create, createSelectors, resetAllStores } from "@/lib/store";
import type { Role, User } from "@/types/auth.type";

export interface Auth extends Omit<User, "role"> {
  isLogin: boolean;
  role: Role | null;
  apiKey: string | null;
}

interface AuthStoreActions {
  initialize: () => void;
  setMe: (me: User) => void;
  login: () => void;
  logout: () => void;
  setApiKey: (apiKey: string | null) => void;
}

const initialState: Auth = {
  id: "",
  nickname: "",
  customerName: "",
  customerId: "",
  taxId: "",
  email: "",
  role: null,
  isLogin: false,
  isFactory: false,
  isSupplier: false,
  isRoot: false,
  isAdmin: false,
  uiConfig: {
    useShipmentRequestFunction: false,
    isSinox: false,
  },
  permissions: {},
  apiKey: null,
};

const useAuthStoreBase = create<Auth & AuthStoreActions>((set, get) => ({
  ...initialState,

  initialize: () => {
    if (!tokenManager.hasRefreshToken || tokenManager.isRefreshTokenExpired) {
      get().logout();
      return;
    }

    set({ isLogin: true });
  },

  setMe: (me: User) => {
    set({ ...me });
    set({ isFactory: me.role === "factory" });
    set({ isSupplier: me.role === "supplier" });
    set({ isRoot: me.role === "root" });
  },

  setApiKey: (apiKey) => set({ apiKey }),

  login: () => set({ isLogin: true }),

  logout: () => {
    tokenManager.deleteTokens();
    resetAllStores();
    set(initialState);
  },
}));

export const useAuthStore = createSelectors(useAuthStoreBase);
